module.exports = __webpack_public_path__ + "images/assets/2330132761279cbdd3a2e50260f4e1a8.svg";